import { Helmet } from 'react-helmet-async';
import './landing-variants.css';

const modules = [
  { id: 'AGD', name: 'AGENDA_SYNC', status: 'ACTIF', desc: 'Planification automatique des fauteuils et créneaux optimisés.' },
  { id: 'PAT', name: 'PATIENT_DB', status: 'ACTIF', desc: 'Dossier clinique contextuel avec accès instantané.' },
  { id: 'FAC', name: 'BILLING_ENGINE', status: 'ACTIF', desc: 'Facturation automatisée, devis et suivi des paiements.' },
  { id: 'ALR', name: 'ALERT_SYSTEM', status: 'STANDBY', desc: 'Notifications intelligentes sans surcharge cognitive.' },
];

const logs = [
  { ts: '08:31:04', msg: 'Patient #1247 check-in confirmé', level: 'OK' },
  { ts: '09:02:17', msg: 'Dossier radiographique synchronisé', level: 'OK' },
  { ts: '10:15:33', msg: 'Facture #F-2026-0891 générée', level: 'OK' },
  { ts: '11:44:02', msg: 'Rappel SMS envoyé → 14 patients', level: 'INFO' },
  { ts: '13:20:51', msg: 'Créneau 14:30 libéré, réaffectation auto', level: 'WARN' },
];

export default function LandingV2() {
  return (
    <div className="doctif-page" style={{
      fontFamily: "'JetBrains Mono', monospace", background: '#000000', color: '#00ff88',
    }}>
      <Helmet><title>doctif — signal.active</title></Helmet>

      {/* Scanline effect */}
      <div aria-hidden style={{
        position: 'fixed', inset: 0, zIndex: 2, pointerEvents: 'none',
        background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,255,136,0.015) 2px, rgba(0,255,136,0.015) 4px)',
      }} />

      {/* Grid dots background */}
      <div aria-hidden style={{
        position: 'fixed', inset: 0, zIndex: 1, pointerEvents: 'none', opacity: 0.08,
        backgroundImage: 'radial-gradient(circle, #00ff88 0.8px, transparent 0.8px)',
        backgroundSize: '28px 28px',
      }} />

      {/* ── Header ── */}
      <header className="doctif-shell" style={{
        padding: '20px 0', borderBottom: '1px solid #0a2a1a', position: 'relative', zIndex: 10,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 10, height: 10, borderRadius: '50%', background: '#00ff88',
              boxShadow: '0 0 10px #00ff88, 0 0 20px #00ff8844',
              animation: 'doctifPulse 2s ease-in-out infinite',
            }} />
            <span style={{ fontSize: 22, fontWeight: 800, color: '#00ff88', letterSpacing: '0.08em' }}>DOCTIF</span>
            <span style={{ color: '#0a4a2a', fontSize: 12 }}>v3.2.1</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <nav className="doctif-chip-row">
              <a className="doctif-chip" href="/1/" style={{ background: '#0a1a10', color: '#0a4a2a', border: '1px solid #0a2a1a' }}>01</a>
              <a className="doctif-chip" href="/2/" style={{ background: '#00ff88', color: '#000' }}>02</a>
              <a className="doctif-chip" href="/3/" style={{ background: '#0a1a10', color: '#0a4a2a', border: '1px solid #0a2a1a' }}>03</a>
            </nav>
            <a href="/accounts/login/" style={{
              color: '#00ff88', fontSize: 12, fontWeight: 700, textDecoration: 'none',
              padding: '6px 14px', border: '1px solid #00ff8844', borderRadius: 4,
            }}>
              LOGIN <span style={{ animation: 'doctifBlink 1s step-end infinite' }}>_</span>
            </a>
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <section className="doctif-shell" style={{
        padding: '60px 0 40px', position: 'relative', zIndex: 5,
        display: 'grid', gridTemplateColumns: '1.1fr 0.9fr', gap: 40, alignItems: 'start',
      }}>
        <div>
          <div className="doctif-fade-up" style={{ color: '#0a4a2a', fontSize: 12, marginBottom: 16 }}>
            {'>'} SYSTEM.INIT :: DENTAL_OPS_PLATFORM
          </div>

          <h1 className="doctif-fade-up doctif-delay-1" style={{
            fontFamily: "'Syne', sans-serif", fontWeight: 700,
            fontSize: 'clamp(2.4rem, 7vw, 5.5rem)', lineHeight: 0.92,
            color: '#ffffff', textTransform: 'uppercase',
            letterSpacing: '-0.03em', marginBottom: 24,
          }}>
            <span style={{ display: 'block' }}>Control</span>
            <span style={{ display: 'block', color: '#00ff88', textShadow: '0 0 30px rgba(0,255,136,0.3)' }}>Everything.</span>
          </h1>

          <p className="doctif-fade-up doctif-delay-2" style={{
            color: '#4a6a5a', fontSize: 14, lineHeight: 1.8, maxWidth: 440, marginBottom: 28,
          }}>
            doctif remplace le chaos clinique par un système nerveux numérique. 
            Chaque patient, chaque rendez-vous, chaque facture — sous contrôle total.
          </p>

          <div className="doctif-fade-up doctif-delay-3" style={{ display: 'flex', gap: 12 }}>
            <a href="/accounts/login/" style={{
              background: '#00ff88', color: '#000', padding: '12px 22px',
              fontWeight: 800, fontSize: 13, textDecoration: 'none', borderRadius: 4,
              boxShadow: '0 0 20px rgba(0,255,136,0.25)',
              transition: 'box-shadow 0.3s',
            }}>
              {'>'} ENTRER
            </a>
            <a href="/booking" style={{
              color: '#00ff88', padding: '12px 22px', fontWeight: 700, fontSize: 13,
              textDecoration: 'none', border: '1px solid #0a2a1a', borderRadius: 4,
            }}>
              DEMO_PATIENT
            </a>
          </div>
        </div>

        {/* Module grid */}
        <div className="doctif-fade-up doctif-delay-2" style={{ display: 'grid', gap: 8 }}>
          {modules.map((m, i) => (
            <div key={m.id} style={{
              background: '#050f0a', border: '1px solid #0a2a1a', borderRadius: 6,
              padding: '14px 16px', display: 'grid', gridTemplateColumns: 'auto 1fr auto', gap: 14,
              alignItems: 'center',
              animation: `doctifSlideIn 0.6s ease ${200 + i * 100}ms both`,
            }}>
              <code style={{ color: '#00ff88', fontSize: 11, fontWeight: 700, padding: '2px 8px', background: '#0a1a10', borderRadius: 3 }}>{m.id}</code>
              <div>
                <div style={{ color: '#ccc', fontSize: 13, fontWeight: 700 }}>{m.name}</div>
                <div style={{ color: '#3a5a4a', fontSize: 11, marginTop: 2 }}>{m.desc}</div>
              </div>
              <span style={{
                fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 3,
                background: m.status === 'ACTIF' ? '#00ff8815' : '#ff880015',
                color: m.status === 'ACTIF' ? '#00ff88' : '#ff8800',
                border: `1px solid ${m.status === 'ACTIF' ? '#00ff8833' : '#ff880033'}`,
              }}>{m.status}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Metrics bar ── */}
      <section style={{
        borderTop: '1px solid #0a2a1a', borderBottom: '1px solid #0a2a1a',
        background: '#020a06', position: 'relative', zIndex: 5,
      }}>
        <div className="doctif-shell" style={{
          display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, padding: '0',
        }}>
          {[
            { v: '240+', l: 'CABINETS' }, { v: '61,247', l: 'RDV/MOIS' },
            { v: '99.8%', l: 'UPTIME' }, { v: '<3s', l: 'RESPONSE' },
          ].map((m, i) => (
            <div key={m.l} className={`doctif-fade-up doctif-delay-${Math.min(i + 1, 5)}`} style={{
              padding: '24px 0', textAlign: 'center',
              borderRight: i < 3 ? '1px solid #0a2a1a' : 'none',
            }}>
              <div style={{ fontFamily: "'Syne', sans-serif", fontSize: 32, fontWeight: 700, color: '#fff' }}>{m.v}</div>
              <div style={{ fontSize: 10, color: '#0a4a2a', letterSpacing: '0.15em', marginTop: 4 }}>{m.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Live log feed ── */}
      <section className="doctif-shell" style={{ padding: '50px 0', position: 'relative', zIndex: 5 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <div style={{
            width: 8, height: 8, borderRadius: '50%', background: '#00ff88',
            animation: 'doctifPulse 1.5s ease-in-out infinite',
          }} />
          <span style={{ fontSize: 12, color: '#0a4a2a', fontWeight: 700, letterSpacing: '0.1em' }}>LIVE_FEED</span>
        </div>

        <div style={{
          background: '#020a06', border: '1px solid #0a2a1a', borderRadius: 8,
          overflow: 'hidden',
        }}>
          {logs.map((log, i) => (
            <div key={i} style={{
              padding: '10px 16px', borderBottom: '1px solid #071510',
              display: 'grid', gridTemplateColumns: 'auto auto 1fr', gap: 16,
              fontSize: 13, animation: `doctifSlideIn 0.5s ease ${300 + i * 80}ms both`,
            }}>
              <code style={{ color: '#0a4a2a' }}>{log.ts}</code>
              <span style={{
                fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 3, alignSelf: 'center',
                color: log.level === 'WARN' ? '#ff8800' : log.level === 'INFO' ? '#60a5fa' : '#00ff88',
                background: log.level === 'WARN' ? '#ff880010' : log.level === 'INFO' ? '#60a5fa10' : '#00ff8810',
              }}>{log.level}</span>
              <span style={{ color: '#8aaa9a' }}>{log.msg}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ borderTop: '1px solid #0a2a1a', position: 'relative', zIndex: 5 }}>
        <div className="doctif-shell" style={{ padding: '60px 0', textAlign: 'center' }}>
          <h2 style={{
            fontFamily: "'Syne', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            fontWeight: 700, color: '#fff', textTransform: 'uppercase', marginBottom: 16,
          }}>
            Prêt à <span style={{ color: '#00ff88', textShadow: '0 0 20px rgba(0,255,136,0.3)' }}>prendre le contrôle</span> ?
          </h2>
          <p style={{ color: '#3a5a4a', fontSize: 14, maxWidth: 440, margin: '0 auto 24px' }}>
            Déploiement en 48h. Support dédié. Aucune carte bancaire requise.
          </p>
          <a href="/accounts/login/" style={{
            display: 'inline-block', background: '#00ff88', color: '#000',
            padding: '14px 28px', fontWeight: 800, fontSize: 14, textDecoration: 'none',
            borderRadius: 4, boxShadow: '0 0 30px rgba(0,255,136,0.3)',
          }}>
            {'>'} ACTIVER_DOCTIF
          </a>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ borderTop: '1px solid #071510', position: 'relative', zIndex: 5 }}>
        <div className="doctif-shell" style={{ padding: '16px 0', display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: '#0a2a1a', fontSize: 12 }}>DOCTIF_SYSTEM v3.2.1</span>
          <span style={{ color: '#0a2a1a', fontSize: 12 }}>Direction brutalist-terminal — Version 02</span>
        </div>
      </footer>

      <style>{`
        @media (max-width: 860px) {
          section[style*='grid-template-columns: 1.1fr'] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
